import PropTypes from "prop-types";
import React, {useEffect, useState, useCallback,useRef} from 'react';

const getWindowData = () => {
    let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0];

    let width = w.innerWidth || e.clientWidth || g.clientWidth;
    let height = w.innerHeight || e.clientHeight || g.clientHeight;

    let windowData = {
        width: width,
        height: height,
        orientation: width > height ? 'landscape' : 'portrait',
    };

    return windowData;
}

const cmsImageFolders = [2560,1920,1440,1024,575,320,120];

const CmsImageLoader = (props) => {

    const [windowSize, setWindowSize] = useState();
    const [inView, setInView] = useState(false);
    const [imageSrc, setImageSrc] = useState();
    const resizeEvt = useRef();
    const imageEl = useRef();
    const stylesOverride = props.stylesOverride;
    const alt = props.alt;

    /** Establish a function to watch for a window resize **/

    const resizeCheck = useCallback(()=>{

        clearTimeout(resizeEvt.current);
        resizeEvt.current = setTimeout(() => {

            let updatedData = getWindowData();
            if (!windowSize || updatedData.width !== windowSize.width || updatedData.height !== windowSize.height) {

                /** updating a state variable will trigger the parent container ref recalculation **/
                setWindowSize(updatedData)
            }

        }, 500);

    },[setWindowSize,windowSize]);

    /** Add your event listeners to run your resize function **/

    useEffect(()=>{

        window.addEventListener('resize', resizeCheck);
        window.addEventListener('orientationchange', resizeCheck);

        resizeCheck();

        return ()=>{
            window.removeEventListener('resize', resizeCheck);
            window.removeEventListener('orientationchange', resizeCheck);
        }

    },[resizeCheck]);

    /** Calculate our parent container dimensions **/

    const calculateParent = (el) => {

        if(el){

            /** set our inview detector element, empty div is fine **/
            imageEl.current = el;

            // /** initialize our intersection observer - Nice to have **/
            // initObserver()

            /** get the parent dimensions that will hold the image **/
            let parentDims = el.parentNode.getBoundingClientRect();

            /** background cover images need a little space outside of their box **/
            let variance = parentDims.height > parentDims.width ? 1.5 : 1;
            let width = parentDims.width * variance;
            if(props.size) width = width * props.size; // flex row items parent may be full window

            /** find the last folder larger than the parent width **/
            let newSize = '2560';
            cmsImageFolders.map((size)=>{
                if(width < size) newSize = size;
            })

            /** update source url **/
            let isOriginal = props.url.includes('/original/',0);
            let isExtraLarge = props.url.includes('/2560/',0)
            let swap = isOriginal ? '/original/' : (isExtraLarge ? '/2560/' : '');
            let newSource = props.url.replace(swap,`/${newSize}/`);

            if(newSource !== imageSrc){
                setImageSrc(newSource)
            }

        }

    }

    // /** first attempt at intersection observer, needed to detect PRIOR to intersection since we are using AOS to
    //  * animate some image in, so the images need to be rendered before entering view or there is a jump
    //  * in the animation
    //  */
    //
    // const initObserver = () => {
    //
    //     let observer = new IntersectionObserver((entry)=>{
    //         if(entry[0].isIntersecting){
    //             setInView(true);
    //             observer.unobserve(imageEl.current);
    //         }
    //     }, { root: null });
    //
    //     observer.observe(imageEl.current);
    //
    // }

    /** calculate if element in viewport, this may need to be fine tuned in the strange case that a user refreshes
     * from the bottom of the page and scrolls up. The dom elements won't render until you get close to the viewport,
     * but that means a jump of content as image spaces render and push content down **/

    const isElementInViewport = useCallback(() => {

        let rect = imageEl.current.getBoundingClientRect();
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        let margin = 100; // may look into adding value of data-aos-offset if used

        let hasEntered = (
            ( rect.top < ( windowHeight + margin ) )
        )

        if(!inView && hasEntered) {        
            setInView(true);
            window.removeEventListener('scroll', isElementInViewport);
        }

    }, [setInView, inView]);

    /** Add your event listeners to detect if element is in view **/

    useEffect(()=>{

        window.addEventListener('scroll', isElementInViewport);

        isElementInViewport();

        return ()=>{
            window.removeEventListener('scroll', isElementInViewport);
        }

    },[isElementInViewport]);

    const getAttributes = () => {

        let attrs = {...props}

        /** remove flags **/
        delete attrs.url;
        delete attrs.background;
        delete attrs.alt; // prop set directly on img tag or linting errors
        delete attrs.stylesOverride;
        delete attrs.dimensions;


        return attrs;

    }

    const calcDimensions = (e) => {
        if(props.dimensions){
            props.dimensions(e.target.width,e.target.height)
        }
    }


    /** If we have a proper image source and in viewport, load our image **/

    const renderImage = () => {

        let attrs = {
            ref:(el)=>calculateParent(el),
            ...getAttributes()
            };

        if(props.loading){
            attrs.loading = props.loading;
        }

        if(!(inView && imageSrc)){
            return <div {...attrs}/>
        } else {
            return props.background ?
                <div {...attrs} style={{backgroundImage: `url(${imageSrc})`}}/> :
                <img {...attrs} src={imageSrc} alt={alt || ''} css={stylesOverride} loading="lazy" onLoad={calcDimensions}/>
        }

    }

    return renderImage()


};

CmsImageLoader.propTypes = {
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
    size: PropTypes.number,
    background: PropTypes.bool,
    dimensions: PropTypes.func,
    loading: PropTypes.string,
};

export default CmsImageLoader
